import { ImageData } from '@jobilla/nexus-sdk'
import { useCallback } from 'react'
import { MediaAsset } from '../../ui'
import { useIsImageGenerated } from './useIsImageGenerated'

export function useConformImageDataToMediaAsset() {
	const isGenerated = useIsImageGenerated()

	return useCallback((asset: ImageData): MediaAsset => {
		return {
			id: asset.id,
			url: asset.url,
			category: 'image' as const,
			name: asset.fileName,
			width: asset.width,
			height: asset.height,
			fileName: asset.fileName,
			humanReadableSize: asset.humanReadableSize,
			createdAt: new Date(asset.createdAt),
			collection: asset.collectionName as MediaAsset['collection'],
			isReady: isGenerated(asset),
		}
	}, [isGenerated])
}
